module.exports = __webpack_public_path__ + "static/img/r-2.db548c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-2.jpg
// module id = X3mn
// module chunks = 0